// components/CheckoutModal.js
import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import NeoButton from "../NeoButton";
import gameMenuBg from "../../@shared/assets/game_menu.png";
import { MainContext } from "../../App";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_KEY2);

const CheckoutModal = ({ visible, onClose, clientSecret }) => {
  const { Theme } = React.useContext(MainContext);
  const options = { clientSecret };

  //   const stripe = useStripe();
  //   const elements = useElements();

  //   const handlePay = async () => {
  //     if (!stripe || !elements) return;
  //     const result = await stripe.confirmCardPayment(clientSecret, {
  //       payment_method: { card: elements.getElement(CardElement) },
  //     });

  //     if (result.error) {
  //       alert("Payment failed: " + result.error.message);
  //     } else {
  //       alert("✅ Payment successful!");
  //       onClose();
  //     }
  //   };

  return (
    <Modal open={visible} onClose={onClose}>
      <Box
        sx={{
          width: "90vw",
          maxWidth: "500px",
          backgroundColor: "#fff",
          borderRadius: 7,
          margin: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 5,
          border: "3px solid #000",
          //   backgroundImage: `url(${gameMenuBg})`,
          //   backgroundSize: "cover",
        }}
      >
        {/* <Typography variant="h6" sx={{ mb: 2, color: "#fff" }}>
          Enter your payment info:
        </Typography> */}

        <Box
          sx={{
            p: 2,
            backgroundColor: Theme.palette.tirciary.main,
            borderRadius: 6,
            maxHeight: "70dvh",
            overflowY: "auto",
            scrollbarWidth: "none",
            border: `8px solid ${Theme.palette.tirciary.dark}`,
          }}
        >
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </Box>

        {/* <NeoButton
          text="Pay"
          color={Theme.palette.primary.main}
          onClick={handlePay}
          style={{ marginTop: 20 }}
        /> */}
      </Box>
    </Modal>
  );
};

export default CheckoutModal;
